var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.75L4.5 6.75H1.5V11.25H4.5L8.25 14.25V3.75Z",
    className: "SoundToggle__Path-sc-jp5fmc-1 SoundToggle__FilledPath-sc-jp5fmc-2 hnNwCb gjkepo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "             M14.3025 3.69751             C15.7086 5.10397 16.4984 7.01128 16.4984 9.00001             C16.4984 10.9887 15.7086 12.8961 14.3025 14.3025           ",
    style: {
      opacity: 1,
      transitionDelay: "150ms"
    },
    className: "SoundToggle__Path-sc-jp5fmc-1 hnNwCb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "             M11.655 6.34501             C12.358 7.04824 12.753 8.00189 12.753 8.99626             C12.753 9.99063 12.358 10.9443 11.655 11.6475           ",
    style: {
      opacity: 1,
      transitionDelay: "0ms"
    },
    className: "SoundToggle__Path-sc-jp5fmc-1 hnNwCb"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/soundOn.2bd4f64a.svg";
export { ForwardRef as ReactComponent };